<template>
  <div class="cart-panel">
    <div class="cart-header">
      <span>已选商品（{{ items.length }} 种）</span>
      <a class="cart-clear" @click="$emit('clear')">清空</a>
    </div>
    <div class="cart-list">
      <div v-for="(item, index) in items" :key="item.key" class="cart-row">
        <div class="row-main">
          <div class="row-name">
            {{ item.name }}
            <span class="row-unit">（{{ item.unit }}）</span>
            <a-tag v-if="item.priceChanged" color="orange" class="row-changed">改</a-tag>
          </div>
          <div class="row-ctrl">
            <div class="stepper">
              <a class="step-btn" @click="changeNumber(index, -1)">−</a>
              <input class="step-input" :value="item.operNumber" inputmode="decimal"
                     @change="onNumberInput(index, $event)" />
              <a class="step-btn" @click="changeNumber(index, 1)">＋</a>
            </div>
            <div class="row-price">
              <div class="row-unit-price" @click="startEditPrice(index)" title="点击改价">
                ¥{{ format(item.unitPrice) }}
              </div>
              <div class="row-all-price">¥{{ format(item.unitPrice * item.operNumber) }}</div>
            </div>
            <a-icon type="close" class="row-remove" @click="$emit('remove', index)" />
          </div>
          <div v-if="editingPriceIndex === index" class="price-edit">
            <span>改价：</span>
            <a-input-number v-model="editingPrice" :min="0" size="small" style="width: 100px"
                            :precision="2" @pressEnter="confirmPrice" />
            <a-button size="small" type="primary" @click="confirmPrice">确定</a-button>
            <a-button size="small" @click="editingPriceIndex = -1">取消</a-button>
          </div>
        </div>
      </div>
      <div v-if="!items.length" class="cart-empty">
        <a-icon type="shopping-cart" />
        <div>点击左侧商品加入购物车</div>
        <div class="cart-empty-tip">支持扫码枪输入条码直接入车</div>
      </div>
    </div>
    <div class="cart-footer">
      <div class="summary-row">
        <span>件数：{{ totalCount }}</span>
        <span>原价合计：¥{{ format(originTotal) }}</span>
      </div>
      <div class="summary-row">
        <span>会员优惠：<span class="discount">-¥{{ format(originTotal - total) }}</span></span>
        <span v-if="member">会员：{{ member.contacts || member.cardNo }}</span>
        <span v-else>散客</span>
      </div>
      <a-button type="primary" size="large" block class="settle-btn" :disabled="!items.length"
                @click="$emit('settle')">
        合计 ¥{{ format(total) }} 结算（F9）
      </a-button>
    </div>
  </div>
</template>

<script>
  /**
   * 购物车常驻右侧：行数量步进（可直接输入）、点击单价改价（留痕）、汇总区（件数/原价/会员优惠/应收大字）
   */
  export default {
    name: 'CartPanel',
    props: {
      items: { type: Array, default: () => [] },
      member: { type: Object, default: null }
    },
    data() {
      return {
        editingPriceIndex: -1,
        editingPrice: 0
      }
    },
    computed: {
      totalCount() {
        return this.items.reduce((sum, i) => sum + Number(i.operNumber || 0), 0)
      },
      total() {
        return this.items.reduce((sum, i) => sum + Number(i.unitPrice || 0) * Number(i.operNumber || 0), 0)
      },
      originTotal() {
        return this.items.reduce((sum, i) => sum + Number(i.basePrice || i.unitPrice || 0) * Number(i.operNumber || 0), 0)
      }
    },
    methods: {
      format(price) {
        return Number(price || 0).toFixed(2)
      },
      changeNumber(index, delta) {
        const item = this.items[index]
        const next = Number(item.operNumber) + delta
        if (next <= 0) {
          this.$emit('remove', index)
          return
        }
        this.$emit('change', { index, operNumber: next })
      },
      onNumberInput(index, e) {
        const value = parseFloat(e.target.value)
        if (!isNaN(value) && value > 0) {
          this.$emit('change', { index, operNumber: value })
        } else {
          e.target.value = this.items[index].operNumber
        }
      },
      startEditPrice(index) {
        this.editingPriceIndex = index
        this.editingPrice = this.items[index].unitPrice
      },
      confirmPrice() {
        if (this.editingPriceIndex > -1 && this.editingPrice !== null && this.editingPrice >= 0) {
          this.$emit('changePrice', { index: this.editingPriceIndex, unitPrice: this.editingPrice })
        }
        this.editingPriceIndex = -1
      }
    }
  }
</script>

<style scoped>
  .cart-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #eee;
  }
  .cart-header {
    padding: 10px 14px;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
  }
  .cart-clear {
    color: #999;
    font-size: 12px;
    font-weight: normal;
  }
  .cart-list {
    flex: 1;
    overflow-y: auto;
    padding: 6px 10px;
  }
  .cart-row {
    border-bottom: 1px dashed #f0f0f0;
    padding: 8px 4px;
  }
  .row-name {
    font-size: 13px;
    color: #333;
  }
  .row-unit {
    color: #999;
    font-size: 12px;
  }
  .row-changed {
    margin-left: 4px;
  }
  .row-ctrl {
    display: flex;
    align-items: center;
    margin-top: 6px;
    gap: 8px;
  }
  .stepper {
    display: flex;
    align-items: center;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: hidden;
  }
  .step-btn {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    color: #555;
    cursor: pointer;
    user-select: none;
    font-weight: 600;
  }
  .step-btn:hover {
    background: #f0f0f0;
  }
  .step-input {
    width: 52px;
    height: 26px;
    border: none;
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    text-align: center;
    outline: none;
    font-size: 13px;
  }
  .row-price {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .row-unit-price {
    color: #333;
    cursor: pointer;
    font-size: 13px;
  }
  .row-unit-price:hover {
    color: #0081ff;
    text-decoration: underline;
  }
  .row-all-price {
    color: #e4393c;
    font-weight: 600;
    font-size: 14px;
  }
  .row-remove {
    color: #bbb;
    cursor: pointer;
    font-size: 13px;
  }
  .row-remove:hover {
    color: #e4393c;
  }
  .price-edit {
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #555;
  }
  .cart-empty {
    text-align: center;
    color: #bbb;
    padding: 50px 0;
    font-size: 13px;
  }
  .cart-empty .anticon {
    font-size: 36px;
  }
  .cart-empty-tip {
    margin-top: 6px;
    font-size: 12px;
    color: #ddd;
  }
  .cart-footer {
    border-top: 1px solid #f0f0f0;
    padding: 10px 14px;
  }
  .summary-row {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 13px;
    margin-bottom: 4px;
  }
  .discount {
    color: #e4393c;
  }
  .settle-btn {
    margin-top: 8px;
    height: 48px;
    font-size: 17px;
    font-weight: 600;
  }
</style>
